module.exports = __webpack_public_path__ + "static/media/perlu_silver_v2.2ecc750e.png";